import { useState } from "react";
import { Inbox, LayoutGrid, Settings2 } from "lucide-react";
import { useMe } from "@/lib/api";
import { Section } from "@/components/site/Bits";
import { PageHero } from "@/night/ui";

const PageHead = ({ kicker, title, desc, children }) => <PageHero en={kicker} ar={title} desc={desc}>{children}</PageHero>;
import { LoginButton } from "@/components/site/UserMenu";
import AdminApps from "@/pages/admin/AdminApps";
import AdminContent from "@/pages/admin/AdminContent";
import AdminSettings from "@/pages/admin/AdminSettings";

const TABS = [
  { id: "apps", label: "التقديمات", icon: Inbox, el: AdminApps },
  { id: "content", label: "محتوى الموقع", icon: LayoutGrid, el: AdminContent },
  { id: "settings", label: "الإعدادات", icon: Settings2, el: AdminSettings },
];

export default function Admin() {
  const { data: me, isLoading } = useMe();
  const [tab, setTab] = useState("apps");
  if (isLoading) return <div className="mx-auto mt-20 h-64 max-w-5xl animate-pulse rounded-2xl bg-slate-900/60" />;
  if (!me) return <PageHead kicker="ADMIN" title="لوحة التحكم" desc="سجّل دخولك بالديسكورد عشان تدخل اللوحة."><div className="mt-8"><LoginButton next="/admin" testid="admin-login-btn" /></div></PageHead>;
  if (!me.is_admin) return <PageHead kicker="ADMIN" title="ما عندك صلاحية" desc="هذي الصفحة لإدارة المدينة بس." />;
  const Cur = TABS.find((t) => t.id === tab).el;
  return (
    <>
      <PageHead kicker="ADMIN PANEL" title="لوحة التحكم" desc={`أهلاً ${me.global_name || me.username}`} />
      <Section className="mt-12">
        <div className="mb-8 flex flex-wrap gap-2" data-testid="admin-tabs">
          {TABS.map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)} className={`flex items-center gap-2 rounded-full border px-5 py-2.5 text-sm transition-colors ${tab === t.id ? "border-sky-400 bg-sky-400/15 text-white" : "border-sky-400/15 text-slate-400 hover:text-white"}`} data-testid={`admin-tab-${t.id}`}>
              <t.icon size={16} />{t.label}
            </button>
          ))}
        </div>
        <Cur />
      </Section>
    </>
  );
}
